import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const alertmedia = defineConnector({
  identifier: "alertmedia",
  name: "AlertMedia",
  tagLine: "Emergency communication and threat intelligence",
  logo,
  protocol: "http",
  tags: ["communication", "security"],
  defaultUrlPattern: () => "https://dashboard\\.alertmedia\\.com/api/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.clientId,
      password: app.secret.clientKey,
    }),
  steps: [
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Generate an API key pair in AlertMedia under **Account Settings → API Keys**. See the [AlertMedia API docs](https://docs.alertmedia.com/reference/connect-to-api).",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "secrets", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client key",
          required: true,
          target: { kind: "secrets", field: "clientKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://dashboard.alertmedia.com/api/v2/login",
  },
});
